<template>
  <div>
    <div
      class="font-weight-medium text-uppercase mr-5 mt-2 cursor-pointer"
      @click="toggleFilterDrawer()"
      v-if="showFilter"
    >
      <span>
        <v-badge color="#F3425C" inline left v-if="filterCounter > 0">
          <template v-slot:badge>
            <span class="font-weight-bold">{{ filterCounter }}</span>
          </template>
        </v-badge></span
      >
      Filters
    </div>
    <v-navigation-drawer
      v-model="filterDrawer"
      class="px-6 pt-6 overflow-y-hidden pr-2"
      id="filter-ticket-drawer"
      width="550px"
      right
      fixed
      :temporary="!saveFilterDialog"
      :permanent="saveFilterDialog"
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left">
            <h5
              class="
                text-h5
                font-weight-600
                float-left
                text-capitalize
              "
            >
              <span v-if="savedFilterId === null" class="secondary--font"> Filters </span>
              <span v-if="savedFilterId !== null" class="secondary--font"> Edit Custom View </span>
            </h5>
          </v-col>
          <v-col align="right">
            <v-btn icon @click.stop="filterDrawer = false" class="float-right"
              v-track="'close-filter-drawer'">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12 py-2">
            <span v-if="savedFilterId === null" class="body-1"> Filter tickets based on below fields. </span>
            <span v-if="savedFilterId !== null" class="secondary--font"> Edit custom view based on below fields </span>
          </v-col>
        </v-row>
        <v-card elevation="0">
          <v-form ref="filterForm" class="mt-1">
            <v-card-text class="px-0">
              <v-text-field
                v-if="savedFilterId"
                label="Filter Name"
                required
                outlined
                v-model="filterName"
                @input="enableApply()"
                :rules="[(v) => !!v || 'Filter name is required', v => /^[a-zA-Z0-9_ ]*$/gm.test(v) || 'Invalid filter name']"
              ></v-text-field>

              <v-autocomplete
                v-model="selectedAgent"
                :items="associatedField.agentList"
                item-value="id"
                item-text="agent_name"
                label="Agents"
                class="customize-select"
                outlined
                clearable
                deletable-chips
                small-chips
                multiple
                attach
                required
                @change="enableApply()"
                :no-filter="true"
                :search-input.sync="searchAgentKeyword"
              >
              </v-autocomplete>

              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="250px"
                class="date-picker-custom"
                offset-y
                attach
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    outlined
                    readonly
                    label="Date Created"
                    v-bind="attrs"
                    hide-details
                    v-on="on"
                    class="date-filter"
                    id="date-range-picker"
                    append-icon="event"
                    @click:append="menu = true"
                    clearable
                    @click:clear="clearSelectedDates"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  :max="maxDate"
                  range
                  full-width
                  no-title
                  color="#03B6FC"
                  :data-popover="{ visibility: 'click' }"
                  :input-props="{ placeholder: 'Select Date' }"
                  @drag="dragValue = $event"
                  scrollable
                  @change="enableApply()"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="clearSelectedDates"
                    class="font-weight-bold"
                    id="cancel-filter"
                    v-track="'clear-selected-dates'"
                    >Clear</v-btn
                  >
                  <v-btn
                    text
                    class="font-weight-bold"
                    id="confirm-date-filter"
                    v-track="'ok-selected-date'"
                    @click="menu = false"
                    >Ok</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <div class="mt-6">
                <ContactsField
                  :key="filterDrawer + 'selectedContact'"
                  type="selectedContact"
                  :selectedContact="selectedContact"
                  page="filter"
                  :multiSelect="true"
                  @getValue="
                    selectedContact = $event;
                    enableApply();
                  "
                  ref="contactFieldDropdown"
                ></ContactsField>
              </div>
              <v-autocomplete
                v-model="status"
                :items="associatedField.statusList"
                :item-text="
                  (item) =>
                    item.name ? item.name.replace('_', ' ') : item.name
                "
                item-value="value"
                label="Status"
                class="customize-select"
                outlined
                chips
                clearable
                deletable-chips
                small-chips
                attach
                multiple
                required
                @change="enableApply()"
              ></v-autocomplete>

              <v-autocomplete
                v-model="priority"
                :items="associatedField.priorities"
                item-text="name"
                item-value="value"
                label="Priority"
                class="customize-select"
                outlined
                chips
                clearable
                deletable-chips
                small-chips
                attach
                multiple
                required
                @change="enableApply()"
              ></v-autocomplete>

              <v-autocomplete
                v-model="channel"
                :items="filteredChannelList"
                :item-text="
                  (item) =>
                    item.name ? item.name.replace('_', ' ') : item.name
                "
                item-value="value"
                label="Channel"
                class="customize-select"
                outlined
                chips
                clearable
                deletable-chips
                small-chips
                attach
                multiple
                required
                @change="enableApply()"
              ></v-autocomplete>

              <!-- <v-autocomplete
                v-model="group"
                :items="associatedField.groups.list"
                item-text="name"
                item-value="id"
                label="Group"
                autocomplete="off"
                outlined
                multiple
                chips
                clearable
                deletable-chips
                small-chips
                @change="enableApply()"
              >
                <template v-slot:append-item>
                  <div
                    v-intersect="loadMoreGroups"
                    class="pa-4 teal--text"
                  ></div>
                </template>
              </v-autocomplete> -->

              <v-autocomplete
                v-model="type"
                :items="associatedField.types.list"
                item-text="name"
                item-value="id"
                label="Type"
                autocomplete="off"
                outlined
                multiple
                chips
                clearable
                deletable-chips
                small-chips
                attach
                @change="enableApply()"
              >
                <template v-slot:append-item>
                  <div
                    v-intersect="loadMoreTicketTypes"
                    class="pa-4 teal--text"
                  ></div>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="tags"
                :items="associatedField.tagList"
                item-value="id"
                item-text="name"
                label="Tags"
                class="customize-select"
                outlined
                chips
                clearable
                deletable-chips
                small-chips
                attach
                multiple
                required
                @change="enableApply()"
                :search-input.sync="searchTagKeyword"
                :no-filter="true"
              ></v-autocomplete>
            </v-card-text>
          </v-form>
        </v-card>
      </div>
      <template v-slot:append>
        <div class="pa-2">
          <v-card-actions class="px-0 d-flex align-end">
            <v-btn
              v-if="savedFilterId"
              class="font-weight-bold mb-4"
              v-track="'cancel-selected-filters'"
              @click.stop="filterDrawer = false"
              outlined
              >Cancel</v-btn
            >
            <v-btn
              v-if="savedFilterId"
              class="font-weight-bold mb-4"
              v-track="'save-selected-filters'"
              @click.stop="saveSelectedFilter()"
              :dark="isSaveActive"
              :disabled="!isSaveActive"
              >Update & Save</v-btn
            >
          
            <v-btn
              v-if="!savedFilterId"
              class="font-weight-bold mb-4"
              v-track="'save-filter'"
              @click.stop="toggleSaveFilterDialog()"
              :disabled="!isSaveActive"
              outlined
              >Save Filter</v-btn
            >
            <v-btn
              v-if="(filterCounter > 0 || (filterCounter > 0 && savedFilterId != null && filterName !== '') || addFilterMode)"
              class="font-weight-bold mb-4"
              v-track="'clear-selected-filter'"
              @click.stop="clearSelectedFilter()"
              outlined
              >Clear Filter</v-btn
            >
            <v-btn
              v-if="!savedFilterId && showFilter"
              id="apply-filter"
              :dark="actionButton"
              :disabled="!actionButton"
              class="font-weight-bold mb-4"
              v-track="'apply-filter'"
              @click="applyFilter()"
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Save filter dialog box -->
    <SaveFilterDialog 
      ref="refSaveFilterDialog" 
      :saveFilterDialog="saveFilterDialog" 
      @evtOnSaveView="saveSelectedFilter"
      @toggleSaveFilterDialog="toggleSaveFilterDialog" />

  </div>
</template>
<script>
//import CustomDropDown from "@/components/ui/CustomDropDown";
import ContactsField from "@/components/tickets/ContactsField";
import { ticketMixin } from "@/mixins/ticket";
import { $filter } from "@/services/Index";
import SaveFilterDialog from "@/components/tickets/SaveFilterDialog";

export default {
  name: "filter-drawer",
  mixins: [ticketMixin],
  components: {
    //CustomDropDown,
    ContactsField,
    SaveFilterDialog,
  },
  props: ['currentTab'],
  watch: {
    filterDrawer(value){
      this.enableSaveButton();
      if(value === false && this.filterMode === 'EDIT'){
        this.$store.dispatch("tickets/savedFilterId", null);
      }
    },
  },
  data() {
    return {
      filterDrawer: false,
      filterCounter: 0,
      selectedAgent: [],
      actionButton: false,
      status: [],
      priority: [],
      channel: [],
      group: [],
      type: [],
      selectedContact: [],
      agentList: [],
      menu: false,
      dates: [],
      dateMenu: false,
      maxDate: new Date().toISOString().substr(0, 10),
      range: {},
      saveFilterDialog: false,
      filterName: '',
      isSaveActive: false,
      addFilterMode: false,
      tags: [],
      tagList: [],
      searchKeyword: null,
    };
  },
  computed: {
    currentAccountId() {
      return this.$store.getters["auth/account"].id;
    },
    filterAccountId(){
      return this.$store.getters["tickets/filterAccountId"];
    },
    filterMode(){
      return this.$store.getters["tickets/filterMode"];
    },
    savedFilterId(){
      return this.$store.getters["tickets/savedFilterId"];
    },
    associatedField() {
      return this.$store.getters["tickets/associatedField"];
    },
    dateRangeText() {
      let date = null;
      if (this.dates && this.dates.length) {
        this.enableApply();
        date = this.sortedDate();
        if (date.length) {
          date = date.map((element) => {
            return this.formatedDate(element);
          });
        }
        date = date.join(" ~ ");
      }
      return date;
    },

    filteredChannelList() {
      let filteredList = this.associatedField.channelList.filter((channel) => {
        return channel.name !== "webstore";
      });
      return filteredList;
    },
    showFilter() {
      return this.$route.name !== 'my-tickets' && this.$route.name !== 'high-priority-tickets'
    },
  },
  mounted() {
    this.getFilteredData();
    this.checkFilterCount();
    if(this.filterAccountId && (this.filterAccountId !== this.currentAccountId)){
      this.reSetFilter();
      this.$store.dispatch("tickets/selectedFilterId", null);
      this.$emit("applyFilter");
    }
  },
  methods: {
    formatedDate(date) {
      return this.$options.filters.localFormatDate(date, "MMM DD, YYYY");
    },
    enableApply() {
      if(this.selectedAgent.length || this.dates.length || this.selectedContact.length || this.status.length || this.priority.length || this.channel.length || this.type.length || this.tags.length) {
        this.actionButton = true;
        this.isSaveActive = true;
      } else {
        this.actionButton = false;
        this.isSaveActive = false;
      }
    },

    enableSaveButton(){
      if(this.selectedAgent.length || this.dates.length || this.selectedContact.length || this.status.length || this.priority.length || this.channel.length || this.type.length || this.tags.length) {
        this.isSaveActive = true;
      } else {
        this.isSaveActive = false;
      }
    },
    /** sort selected dates to ascending to descending */
    sortedDate() {
      this.dates.sort(function (a, b) {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
      });
      return this.dates;
    },

    /* clear all the selected date on click of cancel button */
    clearSelectedDates() {
      this.menu = false;
      if (this.dates.length !== 0) {
        this.dates = [];
      }
      this.enableApply();
    },

    /** Method to open drawer */
    toggleFilterDrawer(action) {
      this.filterDrawer = true;
      this.actionButton = false;
      if(action === 'ADD'){
        this.addFilterMode = true;
      }
      this.getFilteredData();
    },

    /** method to get all the filtered data saved in store */
    getFilteredData() {
      if(this.savedFilterId){ //Update case here
        this.getFilterDataByView(this.savedFilterId);
      } else {
        let filterData = this.$store.getters["tickets/filterData"];
        this.status = filterData.status;
        this.selectedAgent = filterData.selectedAgent;
        this.dates = filterData.dates;
        this.priority = filterData.priority;
        this.channel = filterData.channel;
        this.group = filterData.group;
        this.type = filterData.type;
        this.selectedContact = filterData.selectedContact;
        this.tags = filterData.tags;
      }
    },

    /** Method to set data in store */
    setDataInStore() {
      let filterData = {
        status: this.status,
        priority: this.priority,
        channel: this.channel,
        type: this.type,
        group: this.group,
        selectedContact: this.selectedContact,
        selectedAgent: this.selectedAgent,
        dates: this.dates,
        tags:this.tags,
      };
      this.$store.dispatch("tickets/filterData", [filterData]);
    },

    /** Method to apply filter on clicking of apply button */
    async applyFilter() {
      let startDate = null;
      let endDate = null;
      if (this.dates.length) {
        if (this.dates.length > 1) {
          this.dates = this.sortedDate();
          startDate = this.dates[0];
          endDate = this.dates[1];
        } else {
          startDate = this.dates[0];
          endDate = this.dates[0];
        }
      }
      let groupName = "group_id_in";
      let typeName = "ticket_type_id_in";
      let agentName = "agent_id_in";
      let tagName = "tags_id_in";
      if (this.group && this.group[0] == "blank") groupName = "group_id_blank";
      if (this.type && this.type[0] == "blank") {
        typeName = "ticket_type_id_blank";
      }
      if (this.selectedAgent && this.selectedAgent[0] == "blank") {
        agentName = "agent_id_blank";
      }
      if (this.tags && this.tags[0] == "blank") {
        tagName = "tag_id_blank";
      }

      const selectedTags = this.tagList.filter(item=>this.tags.includes(item.id)).map(tag => tag.name);
      let data = {
        status_in: this.status,
        priority_in: this.priority,
        channel_in: this.channel,
        [typeName]: this.type && this.type[0] == "blank" ? true : this.type,
        [groupName]: this.group && this.group[0] == "blank" ? true : this.group,
        [agentName]:
          this.selectedAgent && this.selectedAgent[0] == "blank"
            ? true
            : this.selectedAgent,

        created_at_gteq: startDate,
        created_at_lteq: endDate,
        contact_id_in: this.selectedContact,
        [tagName]: selectedTags && this.tags[0] == "blank" ? true : this.tags,
      };
      this.$store.dispatch("tickets/appliedFilter", [data]);
      this.$store.dispatch("tickets/filterAccountId", this.currentAccountId);
      this.setDataInStore();
      await this.$emit("applyFilter");
      this.checkFilterCount();
      this.filterDrawer = false;
    },

    /** method to count the applied filter */
    checkFilterCount() {
      let appliedFilter = this.$store.getters["tickets/appliedFilter"];
      this.filterCounter = 0;
      for (var key in appliedFilter) {
        if (appliedFilter[key] && appliedFilter[key].length !== 0) {
          this.filterCounter = this.filterCounter + 1;
        }
      }
      if((appliedFilter['created_at_gteq'] && appliedFilter['created_at_gteq'] !== null) && (appliedFilter['created_at_lteq'] && appliedFilter['created_at_lteq'] !== null)){
        this.filterCounter -= 1;
      }
    },

    /** Method to clear selected filter on clicking of clear filter button */
    async clearSelectedFilter() {
      if(this.currentTab === 'custom-view'){
        this.$store.dispatch("tickets/selectedFilterId", null);
      }
      this.reSetFilter('drawer');
      await this.$emit("applyFilter");
      this.filterDrawer = false;
    },
    /**
     * Function to get saved filter data using API call based on the supplied identity.
     * @param {*} viewId 
     */
    async getFilterDataByView(viewId){
      try {
        const response = await $filter.fetchFilter(viewId);
        this.filterName = response.data.name
        const filterData = response.data.query;
        this.status = filterData.status_in;
        this.selectedAgent = filterData.agent_id_in;
        this.tags = filterData.tags_id_in;
        this.dates = [];
        
        if(filterData.created_at_gteq){
          this.dates.push(filterData.created_at_gteq);
        } 
        
        if(filterData.created_at_lteq) {
          if(filterData.created_at_gteq !== filterData.created_at_lteq){
            this.dates.push(filterData.created_at_lteq);
          }
        }
        this.priority = filterData.priority_in;
        this.channel = filterData.channel_in;
        this.group = filterData.group_id_in;
        this.type = filterData.ticket_type_id_in;
        this.selectedContact = filterData.contact_id_in;

        if ( this.selectedContact !== null && this.selectedContact.toString().length > 0 ) {
          this.$refs.contactFieldDropdown.contactTicketId = this.selectedContact;
          this.$refs.contactFieldDropdown.getContactList(this.selectedContact);
        }
        if (this.selectedAgent !== null && this.selectedAgent.toString().length > 0 ) {
          this.getAgentList(this.selectedAgent, 'ID')
        }
        this.$store.dispatch("tickets/filterData", [filterData]);
      } catch (error) {}
    },
    /**
     * Function to save/update filter for future use.
     */
    async saveSelectedFilter(filterName) {
      const valid = await this.$refs.filterForm.validate()
      if(!valid) { return }
      this.actionButton = false;
      let startDate = null;
      let endDate = null;
      if (this.dates.length) {
        if (this.dates.length > 1) {
          this.dates = this.sortedDate();
          startDate = this.dates[0];
          endDate = this.dates[1];
        } else {
          startDate = this.dates[0];
          endDate = this.dates[0];
        }
      }
      const payload = {
        filter: {
          name: (filterName) ? filterName : this.filterName,
          query: {
            subject_cont: "",
            description_cont: "",
            id_in: "",
            m: "and",
            status_in: this.status,
            priority_in: this.priority,
            channel_in: this.channel,
            ticket_type_id_in: this.type,
            group_id_in: this.group,
            agent_id_in: this.selectedAgent,
            tags_id_in: this.tags,
            created_at_gteq: startDate,
            created_at_lteq: endDate,
            contact_id_in: this.selectedContact,
          }
        }
      }
      try {
        let response = {};
        if(this.savedFilterId !== null){
          response = await $filter.updateFilter(this.savedFilterId, payload);
        } else {
          response = await $filter.createFilter(payload);
        }
        if(response){
          let title = "Custom View"
          let message = `Custom view has been saved successfully.`
          if(this.savedFilterId !== null) {
            title = "Custom View";
            message = `Custom View has been edited successfully.`
          } 
          this.saveFilterDialog = false;
          
          this.clearSelectedFilter();
          this.$store.dispatch("ui/snackbar", [{title, message, type: "success", }]);
          this.actionButton = true;
        }
      } catch (error) {
        if (error.response !== undefined) {
          if(this.savedFilterId !== null) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          } else {
            this.$refs.refSaveFilterDialog.saveError = this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `
              })
          }
        }
      }
      this.$emit("onViewListLoad");
    },
    /** Method to save selected filter on clicking of save filter button */
    toggleSaveFilterDialog() {
      this.saveFilterDialog = !this.saveFilterDialog;
      this.$refs.refSaveFilterDialog.resetValidation()
      this.$refs.refSaveFilterDialog.reset()
    },

    /** Method to reset the applied filter */
    reSetFilter(from = '') {
      let customViewId = this.savedFilterId;
      this.selectedAgent = [];
      this.status = [];
      this.priority = [];
      this.channel = [];
      this.group = [];
      this.selectedContact = [];
      this.type = [];
      this.dates = [];
      this.tags = [];
      this.$store.dispatch("tickets/appliedFilter", [{}]);
      this.setDataInStore();
      this.$store.dispatch("tickets/filterMode", '');
      this.$store.dispatch("tickets/savedFilterId", null);
      this.$store.dispatch("tickets/filterAccountId", null);
      this.checkFilterCount();
      this.getFilteredData();
      if(customViewId !== null && from === 'drawer'){
        this.$router.push({ name: 'tickets' }).catch(err => {})
      }
    },
  },
};
</script>

<style>
.v-date-picker-table {
  height: 220px !important;
}

</style>
